export const setStylesOnElement = (domElement, styles) => {
  Object.assign(domElement.style, styles);
}


// WEBPACK FOOTER //
// ./utils/dom.js